'use strict';

var blz = blz || {};
var navClassArrow = [
  'carousel-nav-arrow-left icon-arrow-left',
  'carousel-nav-arrow-right icon-arrow-right'
];

var options = {
  loop: true,
  nav: true,
  dots: true,
  navText: ['', ''],
  dotsClass: 'carousel-dots',
  dotClass: 'carousel-dot',
  navContainerClass: 'carousel-nav-arrows',
  navClass: navClassArrow
};

var carouselConfigs = {
  'js-carousel-1': $.extend({}, options, {
    items: 1,
    dots: false,
    loop: true,
    autoplay: false,
    responsive: {
      0: {
        nav: false
      }
    }
  }),

  'js-carousel-2': $.extend({}, options, {
    responsive: {
      0: {
        items: 1
      },
      768: {
        items: 2
      }
    }
  }),

  'js-carousel-2-sidebar': $.extend({}, options, {
    responsive: {
      0: {
        items: 1
      },
      320: {
        items: 2,
        slideBy: 2,
        margin: 10
      }
    },
    navContainerClass: 'carousel-nav-arrows is-small'
  }),

  'js-carousel-1-sidebar': $.extend({}, options, {
    items: 1,
    dots: true,
    loop: true,
    autoplay: false,
    responsive: {
      0: {
        nav: false
      }
    },
    navContainerClass: 'carousel-nav-arrows is-small'
  }),

  'js-carousel-2-responsive': $.extend({}, options, {
    responsive: {
      0: {
        items: /special_page/i.test(blz.type) ? 2 : 1,
        margin: /special_page/i.test(blz.type) ? 10 : 1,
        loop: !/special_page/i.test(blz.type)
      },
      768: {
        items: 2,
        margin: 10,
        navClass: '',
        navContainerClass: '',
        nav: false,
        loop: false
      }
    }
  }),

  'js-carousel-3': $.extend({}, options, {
    navSpeed: 150,
    loop: false,
    lazyLoad: true,
    responsive: {
      0: {
        items: 2,
        margin: 15
      },
      520: {
        items: 2,
        slideBy: 2,
        margin: 20
      },
      768: {
        items: 3,
        slideBy: 3,
        margin: 20
      }
    }
  }),

  'js-carousel-3-responsive': $.extend({}, options, {
    lazyLoad: true,
    responsive: {
      0: {
        items: 1
      },
      520: {
        items: 2,
        slideBy: 2,
        margin: 10
      },
      768: {
        items: 3,
        slideBy: 3,
        navClass: '',
        margin: 10,
        navContainerClass: '',
        nav: false,
        loop: false
      }
    }
  }),

  'js-carousel-4': $.extend({}, options, {
    navSpeed: 100,
    loop: false,
    lazyLoad: true,
    responsive: {
      0: {
        items: 2,
        slideBy: 2,
        margin: 15
      },
      768: {
        items: 4,
        slideBy: 4,
        margin: 30
      }
    }
  }),

  'js-carousel-5': $.extend({}, options, {
    navSpeed: 100,
    loop: false,
    lazyLoad: true,
    responsive: {
      0: {
        items: 2,
        slideBy: 2,
        margin: 10
      },
      520: {
        items: 3,
        slideBy: 3,
        margin: 10
      },
      768: {
        items: 4,
        slideBy: 4,
        margin: 10
      },
      1220: {
        items: 5,
        slideBy: 5,
        margin: 10
      }
    }
  }),

  'js-carousel-brand': $.extend({}, options, {
    slideBy: 6,
    lazyLoad: true,
    autoWidth: true,
    navContainerClass: 'carousel-nav-arrows is-small'
  }),

  'physical-store-carousel': $.extend({}, options, {
    lazyLoad: true,
    loop: true,
    autoplay: true,
    stagePadding: 40,
    fluidSpeed: 50,
    dots: false,
    responsive: {
      0: {
        items: 2,
        dots: false,
        stagePadding: 30
      },
      520: {
        dots: false,
        items: 3
      },
      768: {
        items: 4,
        dots: false
      }
    }
  }),

  'carousel-trends-slide': $.extend({}, options, {
    items: 2,
    dots: false,
    loop: true,
    autoplay: false,
    responsive: {
      0: {
        items: 1.2
      },
      768: {
        items: 2
      }
    }
  }),

  'services-carousel-slide': $.extend({}, options, {
    items: 3,
    dots: false,
    loop: true,
    autoplay: false,
    responsive: {
      0: {
        items: 1
      },
      768: {
        items: 3
      }
    }
  }),

  'club-benefits-slide': $.extend({}, options, {
    items: 1,
    dots: false,
    loop: true,
    autoplay: false
  })
};

var Carousel = {
  render: function render() {
    if (
      ($('body').hasClass('is-mobile') &&
        !$('body').hasClass('page-products') &&
        !$('body').hasClass('page-store')) ||
      /minha-conta|transacional|rastreio/.test(location.pathname)
    ) {
      return;
    }

    if (!$.fn.owlCarousel && blz.utils) {
      return blz.utils.loadjs(
        blz.globals.cdnPath + blz.globals.rawPath + '/assets/js/owl.carousel.min.js',
        function () {
          Carousel.init();
        }
      );
    }

    Carousel.init();
  },

  init: function init() {
    $('.js-carousel-simple').owlCarousel({
      items: 1,
      loop: false,
      nav: false,
      dotsClass: 'carousel-dots',
      dotClass: 'carousel-dot',
      dots: true
    });

    for (var i in carouselConfigs) {
      $('.' + i).owlCarousel(carouselConfigs[i]);
    }
  }
};

Carousel.render();

$('body').on(
  'click',
  '.carousel-nav-arrows .carousel-nav-arrow-left, .carousel-nav-arrows .carousel-nav-arrow-right',
  function () {
    var $this = $(this);
    var $carousel = $this.closest('.js-carousel');
    var carouselWidth = $carousel.width() + 10;
    var leftNav = 'carousel-nav-arrow-left';
    var rightNav = 'carousel-nav-arrow-right';
    var direction = $this.hasClass(leftNav) ? '-=' : '+=';

    $carousel.animate({ scrollLeft: direction + carouselWidth }, function () {
      var carouselWidth = $carousel.width();

      if ($carousel[0].scrollLeft + 10 > $carousel[0].scrollWidth - carouselWidth) {
        $carousel.find('.' + rightNav).addClass('disabled');
      } else {
        $carousel.find('.' + rightNav).removeClass('disabled');
      }

      if ($carousel[0].scrollLeft > 0) {
        $carousel.find('.' + leftNav).removeClass('disabled');
      } else {
        $carousel.find('.' + leftNav).addClass('disabled');
      }
    });
  }
);

module.exports = Carousel;
